var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99148 19.2H14.0101C17.6469 19.2 19.2008 17.6461 19.2008 14.0093V12.6698C19.2008 12.3952 18.9731 12.1674 18.6985 12.1674C18.4239 12.1674 18.1961 12.3952 18.1961 12.6698V14.0093C18.1961 17.0969 17.0977 18.1953 14.0101 18.1953H9.99148C6.90385 18.1953 5.80543 17.0969 5.80543 14.0093V9.99069C5.80543 6.90306 6.90385 5.80464 9.99148 5.80464H11.331C11.6056 5.80464 11.8333 5.57692 11.8333 5.30231C11.8333 5.02771 11.6056 4.79999 11.331 4.79999H9.99148C6.35464 4.79999 4.80078 6.35385 4.80078 9.99069V14.0093C4.80078 17.6461 6.35464 19.2 9.99148 19.2ZM18.6985 9.01952C18.4239 9.01952 18.1961 8.7918 18.1961 8.5172V6.51458L13.0255 11.6852C12.9251 11.7857 12.7978 11.8325 12.6705 11.8325C12.5433 11.8325 12.416 11.7857 12.3156 11.6852C12.1213 11.491 12.1213 11.1695 12.3156 10.9752L17.4862 5.80464H15.4836C15.209 5.80464 14.9813 5.57692 14.9813 5.30231C14.9813 5.02771 15.209 4.79999 15.4836 4.79999H18.6985C18.9731 4.79999 19.2008 5.02771 19.2008 5.30231V8.5172C19.2008 8.7918 18.9731 9.01952 18.6985 9.01952Z",
    fill: "#A3A4A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.eb8f1b40375d9d35614ba7e0b6fe2562.svg";
export { ForwardRef as ReactComponent };